import React from "react";

import cx from "classnames";

import { ReactComponent as GetaroundLogo } from "../images/getaround.svg";
import { ReactComponent as MotiveLogo } from "../images/motive.svg";
import { ReactComponent as ShopifyLogo } from "../images/shopify.svg";
import { ReactComponent as SurveyMonkeyLogo } from "../images/surveymonkey.svg";
import { ReactComponent as VidyardLogo } from "../images/vidyard.svg";

import styles from "../css/Auth.module.css";

export default function CompanyLogos() {
	return (
		<div className={cx(styles.shiftedDown, styles.largeMonitorOnly)}>
			<h3>You&apos;re in good company</h3>

			<div className={styles.customerLogos}>
				<div>
					<ShopifyLogo></ShopifyLogo>
				</div>
				<div>
					<GetaroundLogo></GetaroundLogo>
				</div>
				<div>
					<SurveyMonkeyLogo></SurveyMonkeyLogo>
				</div>
				<div>
					<VidyardLogo></VidyardLogo>
				</div>
				<div>
					<MotiveLogo></MotiveLogo>
				</div>
			</div>
		</div>
	);
}
